<div class="login-page">
  <div class="col-left" *ngIf="imagePath" [ngStyle]="{ 'background-image': 'url(' + imagePath + ')' }"></div>
  <div class="col-left" *ngIf="imagePath == undefined">
    <div class="swiper mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="https://reflecx.io/accounts/desktop/images/slide-1.jpg" />
          <div class="slider-caption">
            <p>Pursue the perfect<br />customer experience.</p>
          </div>
        </div>
        <div class="swiper-slide">
          <img src="https://reflecx.io/accounts/desktop/images/slide-2.jpg" />
          <div class="slider-caption">
            <p>Listen, aggregate and<br />act across every channel.</p>
          </div>
        </div>
        <div class="swiper-slide">
          <img src="https://reflecx.io/accounts/desktop/images/slide-3.jpg" />
          <div class="slider-caption">
            <p>Say hello to RefleCX. Everything<br />you need for proactive CX.</p>
          </div>
        </div>
      </div>
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
  <div class="col-right">
    <form [formGroup]="setPassForm" style="height: 100%">
      <div class="login-form">
        <div class="form">
          <div class="form__inner">
            <div class="form__header">
              <div class="login-logo">
                <img src="./assets/styles/portal/build/assets/images/reflecx-logo.svg" alt="" />
              </div>

              <h4>Thank you for confirming code</h4>
              <p class="small-text">Please set password for your account</p>
            </div>

            <fieldset
              class="form__group"
              [ngClass]="{
                'error--field':
                  isPasswordPolicyError || (submitted && f.newPassword.errors && f.newPassword.errors?.required)
              }"
            >
              <label class="form__label">ENTER PASSWORD</label>
              <div class="form__field">
                <div class="password-strength">
                  <input
                    type="Password"
                    formControlName="newPassword"
                    (keyup)="onPaswordChange($event.target.value)"
                    class="form__input"
                    autocomplete="new-form"
                  />
                  <div class="password-strength-bar">
                    <div *ngIf="strengthColor == 'red'" class="password-strength-block weak"></div>

                    <div *ngIf="strengthColor == 'orange'" class="password-strength-block moderate"></div>
                    <div *ngIf="strengthColor == 'orange'" class="password-strength-block moderate"></div>

                    <div *ngIf="strengthColor == 'green'" class="password-strength-block strong"></div>
                    <div *ngIf="strengthColor == 'green'" class="password-strength-block strong"></div>
                    <div *ngIf="strengthColor == 'green'" class="password-strength-block strong"></div>
                  </div>
                </div>
              </div>

              <div class="field__error" *ngIf="submitted">
                <p *ngIf="f.newPassword.errors && f.newPassword.errors?.required">
                  {{ 'New password is required.' }}
                </p>
                <p *ngIf="!f.newPassword.errors?.required && passwordPolicy != null && isPasswordPolicyError">
                  {{ passwordPolicyError }}
                </p>
              </div>
            </fieldset>

            <fieldset
              class="form__group"
              [ngClass]="{
                'error--field':
                  submitted &&
                  ((f.confirmPassword.errors && f.confirmPassword.errors.required) ||
                    (f.confirmPassword.errors && f.confirmPassword.errors.mustMatch))
              }"
            >
              <label class="form__label">RE-TYPE PASSWORD</label>
              <div class="form__field">
                <input type="Password" formControlName="confirmPassword" class="form__input" autocomplete="new-form" />

                <div class="field__error" *ngIf="submitted">
                  <p *ngIf="f.confirmPassword.errors && f.confirmPassword.errors.required">
                    {{ 'Confirm password is required.' }}
                  </p>
                  <p *ngIf="f.confirmPassword.errors && f.confirmPassword.errors.mustMatch">
                    {{ 'Password must Match.' }}
                  </p>
                </div>
              </div>
            </fieldset>

            <fieldset class="form__group">
              <div *ngIf="passwordPolicy != null">
                <p class="password-hints-title">PASSWORD HINT</p>
                <div class="password-hints">
                  <ul class="">
                    <li *ngIf="passwordPolicy.IsUpperCase">New Password must have at least one upper case character</li>
                    <li *ngIf="passwordPolicy.IsLowerCase">Must have at least one lower case character</li>
                    <li *ngIf="passwordPolicy.IsSpecialCharacter">Must have at least one symbol</li>
                    <li *ngIf="passwordPolicy.IsDigit">Must have at least one digit</li>
                    <li *ngIf="passwordPolicy.Length > 0">
                      Password must be minimum {{ passwordPolicy.Length }} characters long
                    </li>
                  </ul>
                </div>
              </div>
            </fieldset>

            <fieldset class="form__group login--actions">
              <div class="auth-button">
                <button class="login-btn" type="button" (click)="setPassword()">CHANGE</button>
              </div>
            </fieldset>
          </div>
        </div>
      </div>
    </form>
  </div>
</div>
